import { featureFlag } from "./featureFlags";

export type FeatureFlags =
  | "FEATURE_FLAG_DISCORD_GIVEAWAY_0123"
  | "SEGMENT"
  | "HARDCODE_HAMILTON_HOLDINGS"
  | "CASH_HOLDINGS_ENABLE"
  | "FEATURE_FLAG_APRIME_PRICING_GRAPH";

export const FLAGS = {
  get isECFEnabled() {
    return featureFlag("ecf");
  },
};

/**
 * High-level pages protected by feature flags.
 * Do NOT put essential investor surfaces here (/kyc, /portfolio) —
 * those are gated by auth / accreditation middleware instead.
 * ECF still controls ECF-specific UI via FLAGS.isECFEnabled.
 */
export const FEATURE_FLAGGED_PAGES: { [key: string]: boolean[] } = {};

/**
 * Whitelist of countries that are allowed to access a feature-flagged page.
 * Only declare the country code here if the page is not allowed for all countries.
 */
export const COUNTRY_FLAGGED_PAGES: { [key: string]: string[] } = {};
